/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

export enum FcAgDatepickerTypes {
    SINGLE_DP,
    SINGLE_DP_WITH_FILTER,
    RANGE_DP,
    RANGE_DP_WITH_FILTER
}